import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateWebhook } from "../../api/apiWebhooks";
import parseError from "../../utils/parseError";

export const useUpdateWebhook = () => {
    const queryClient = useQueryClient();

    const { mutate: updateWebhookMutate, mutateAsync: updateWebhookAsync, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateWebhook(id, data),
        onSuccess: (res) => {
            toast.success(res?.message || "Webhook updated successfully");
            queryClient.invalidateQueries({ queryKey: ["webhooks"] });
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update webhook");
        },
    });

    return { updateWebhookMutate, updateWebhookAsync, isUpdating };
};
